import { Injectable } from '@angular/core';
import { ContextService } from '@app/core/service/context.service';
import { environment } from '@env/environment';
import { OfferFilter } from '@app/core/business/offer/offer-filter';

@Injectable({
  providedIn: 'root',
})
export class OfferStateService {
  public page = 1;
  public limit = environment.availableLimits[0];
  public mode: string;
  public offerCode: string;
  public filters = new Array<OfferFilter>();
  private oldCompanyCode: string;
  public schedulerPages: {
    index: number;
    page: number;
  }[];
  public quickEntryPages: {
    index: number;
    page: number;
  }[];

  constructor(private contextService: ContextService) {
    if (this.mode == '' || this.mode == undefined)
      this.mode = this.contextService.fullContext.company?.settings?.offerDefaultView;
    else
      this.setMode(this.mode);

    this.schedulerPages = [];
    this.quickEntryPages = [];

    // Reset offerState when company change as offer will be different
    contextService.context$.subscribe(c => {
      if (this.oldCompanyCode && this.oldCompanyCode != c.companyCode) {
        this.setMode(undefined);
      }

      this.oldCompanyCode = c.companyCode;
    });
  }

  public setOfferCode(offerCode: string) {
    if (this.offerCode !== offerCode) {
      // Reset pages and filters as they depend on the offer
      this.page = 1;
      this.schedulerPages = [];
      this.quickEntryPages = [];
      this.filters = [];

      this.offerCode = offerCode;
    }
  }

  public setLimit(limit: number) {
    this.limit = limit;

    // Reset page to 1 if limit change as it could result in a wrong page number without
    this.page = 1;
  }

  public setPage(page: number) {
    this.page = page;
  }

  public setFilters(filters: OfferFilter[]) {
    this.filters = filters;
  }

  // Supprime l'ensemble des filtres sélectionnés
  public clearFilters() {
    this.filters = [];
  }

  public setQuickEntryPage(page:number, index: number) {
    // Remove old registered page if it exists
    const removeIndex = this.quickEntryPages.findIndex(sp => sp.index === index);
    if (removeIndex !== -1) {
      this.quickEntryPages.splice(removeIndex, 1);
    }

    // Save page
    this.quickEntryPages.push({
      index: index,
      page: page,
    });
  }
  public setSchedulerPage(page: number, index: number) {
    // Remove old registered page if it exists
    const removeIndex = this.schedulerPages.findIndex(sp => sp.index === index);
    if (removeIndex !== -1) {
      this.schedulerPages.splice(removeIndex, 1);
    }

    // Save page
    this.schedulerPages.push({
      index: index,
      page: page,
    });
  }

  public setMode(mode: string) {
    this.mode = mode;
    this.page = 1;
    this.limit = 20;
  }
}
